import React from 'react'

export const PolicyAddress = () => {
  return (
    <p className="mt-5 max-w-[300px] mx-auto text-center text-[10px]">
      Moballiance LTD, a United Kingdom company, is registered at 61 Bridge Street, Kington, United
      Kingdom, HR5 3DJ.
    </p>
  )
}
